module.exports = __webpack_public_path__ + "static/media/bus-o-echtzeit.f32d4819.svg";